import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Link } from 'react-router-dom';
import HeroSection from './components/hero';
import PortfolioPage from './components/portfolio';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';
import SEO from './components/SEO';
import SubscriptionPage from './components/SubscriptionPage';
import SuccessPage from './pages/SuccessPage';
import CancelPage from './pages/CancelPage';

// FooterWrapper to conditionally render Footer
const FooterWrapper = () => {
  const location = useLocation();
  if (location.pathname === '/') {
    return <Footer />;
  }
  return null;
};

function App() {
  return (
    <Router>
      <SEO
        title="AISS | Web Dev & Automation Solutions"
        description="AISS empowers entrepreneurs with enterprise-level web development, automation, and customer journey solutions. Book your free discovery call today."
        url="https://aiss.solutions/"
        image="https://aiss.solutions/images/og-share.jpg"
      />
      {/* <nav style={{ padding: '1rem', backgroundColor: '#2D3748', color: 'white', textAlign: 'center' }}>
        <Link to="/" style={{ color: 'white', marginRight: '20px', textDecoration: 'none' }}>Home</Link>
        <Link to="/subscriptions" style={{ color: 'white', marginRight: '20px', textDecoration: 'none' }}>Pricing</Link>
      </nav> */}
      <main>
        <Routes>
          <Route path="/" element={<>
            <HeroSection />
            <AboutSection />
            <PortfolioPage />
          </>} />
          <Route path="/subscriptions" element={<SubscriptionPage />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/cancel" element={<CancelPage />} />
        </Routes>
        <FooterWrapper />
      </main>
    </Router>
  );
}

export default App; 